import { render } from "./fileManage.vue?vue&type=template&id=7669e872&scoped=true"
import script from "./fileManage.vue?vue&type=script&lang=js"
export * from "./fileManage.vue?vue&type=script&lang=js"

import "./fileManage.vue?vue&type=style&index=0&id=7669e872&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7669e872"]])

export default __exports__